import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Import\DeleteImportController::__invoke
* @see app/Http/Controllers/Import/DeleteImportController.php
* @route '/api/import/{import}'
*/
const DeleteImportController = (args: { import: string | number | { id: string | number } } | [importParam: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteImportController.url(args, options),
    method: 'delete',
})

DeleteImportController.definition = {
    methods: ["delete"],
    url: '/api/import/{import}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Import\DeleteImportController::__invoke
* @see app/Http/Controllers/Import/DeleteImportController.php
* @route '/api/import/{import}'
*/
DeleteImportController.url = (args: { import: string | number | { id: string | number } } | [importParam: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { import: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { import: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            import: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        import: typeof args.import === 'object'
        ? args.import.id
        : args.import,
    }

    return DeleteImportController.definition.url
            .replace('{import}', parsedArgs.import.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Import\DeleteImportController::__invoke
* @see app/Http/Controllers/Import/DeleteImportController.php
* @route '/api/import/{import}'
*/
DeleteImportController.delete = (args: { import: string | number | { id: string | number } } | [importParam: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteImportController.url(args, options),
    method: 'delete',
})

export default DeleteImportController